import api from '@/api'

const state = {
  packageSizes: [],
  cities: [],
  deliveryServiceCodes: [],
  provinces: [],
  districts: [],
  subDistricts: [],
  urbanVillages: [],
  paymentMethods: [],
  goodsCategories: [],
  goodsCategoryDetail: {},
  bankCodes: [],
  ownershipTypes: [],
  vehicleTypes: [],
  driverLicenseTypes: [],
  pickupSlotTime: []
}
const actions = {
  getPackageSizes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.packageSize().then(
        response => {
          commit('setPackageSizes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCities({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.master.cities(params).then(
        response => {
          commit('setCities', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDeliveryServiceCodes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.deliveryServiceCodes().then(
        response => {
          commit('setDeliveryServiceCodes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getProvinces({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.province().then(
        response => {
          commit('setProvinces', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDistricts({ commit }, { provinceId }) {
    return new Promise((resolve, reject) => {
      api.master.district(provinceId).then(
        response => {
          commit('setDistricts', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getSubDistricts({ commit }, { provinceId, districtId }) {
    return new Promise((resolve, reject) => {
      api.master.subDistrict(provinceId, districtId).then(
        response => {
          commit('setSubDistricts', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getUrbanVillages({ commit }, { provinceId, districtId, subDistrictId }) {
    return new Promise((resolve, reject) => {
      api.master.urbanVillage(provinceId, districtId, subDistrictId).then(
        response => {
          commit('setUrbanVillages', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPaymentMethods({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.paymentMethods().then(
        response => {
          commit('setPaymentMethods', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getPickupSlotTime({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.pickupSlotTime().then(
        response => {
          commit('setPickupSlotTime', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getGoodsCategories({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.goodsCategories().then(
        response => {
          commit('setGoodsCategories', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getGoodsCategoryDetail({ commit }, { code }) {
    return new Promise((resolve, reject) => {
      api.master.goodsCategoryDetail(code).then(
        response => {
          commit('setGoodsCategoryDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createGoodsCategory({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.master.createGoodsCategory(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getBankCodes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.bankCodes().then(
        response => {
          commit('setBankCodes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getOwnershipTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.ownershipTypes().then(
        response => {
          commit('setOwnershipTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getVehicleTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.vehicleTypes().then(
        response => {
          commit('setVehicleTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDriverLicenseTypes({ commit }) {
    return new Promise((resolve, reject) => {
      api.master.driverLicenseTypes().then(
        response => {
          commit('setDriverLicenseTypes', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setPackageSizes(state, value) {
    state.packageSizes = value
  },
  setCities(state, value) {
    state.cities = value
  },
  setDeliveryServiceCodes(state, value) {
    state.deliveryServiceCodes = value
  },
  setProvinces(state, value) {
    state.provinces = value
  },
  setDistricts(state, value) {
    state.districts = value
  },
  setSubDistricts(state, value) {
    state.subDistricts = value
  },
  setUrbanVillages(state, value) {
    state.urbanVillages = value
  },
  setPaymentMethods(state, value) {
    state.paymentMethods = value
  },
  setGoodsCategories(state, value) {
    state.goodsCategories = value
  },
  setGoodsCategoryDetail(state, value) {
    state.goodsCategoryDetail = value
  },
  setBankCodes(state, value) {
    state.bankCodes = value
  },
  setOwnershipTypes(state, value) {
    state.ownershipTypes = value
  },
  setVehicleTypes(state, value) {
    state.vehicleTypes = value
  },
  setDriverLicenseTypes(state, value) {
    state.driverLicenseTypes = value
  },
  setPickupSlotTime(state, value) {
    state.pickupSlotTime = value
  }
}
const getters = {
  packageSizes: state => state.packageSizes,
  cities: state => state.cities,
  deliveryServiceCodes: state => state.deliveryServiceCodes,
  provinces: state => state.provinces,
  districts: state => state.districts,
  subDistricts: state => state.subDistricts,
  urbanVillages: state => state.urbanVillages,
  paymentMethods: state => state.paymentMethods,
  goodsCategories: state => state.goodsCategories,
  goodsCategoryDetail: state => state.goodsCategoryDetail,
  bankCodes: state => state.bankCodes,
  ownershipTypes: state => state.ownershipTypes,
  vehicleTypes: state => state.vehicleTypes,
  driverLicenseTypes: state => state.driverLicenseTypes,
  pickupSlotTime: state => state.pickupSlotTime
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
